import Vue from 'vue';
import KeepButtonGroups from './button';
import KeepActionSheet from './actionSheet';
import KeepCellAddress from './cell-address';
import KeepCellCheckbox from './cell-checkbox';
import KeepCellPanel from './cell-panel';
import KeepCellRadio from './cell-radio';
import KeepCellStepper from './cell-stepper';
import KeepCellSwitch from './cell-switch';
import KeepCollapse from './collapse';
import KeepDatePickerView from './datePickerView';
import KeepBadge from './elements/badge';
import KeepRate from './elements/rate';
import KeepList from './list';
import KeepOptionModal from './modal/operationModal';
import KeepTipsModal from './modal/tipsModal';
import KeepNavBar from './navBar';
import KeepPicker from './picker';
import KeepTabBar from './tabBar';
import KeepCorner from './corner';
import KeepActIndicator from './activityIndicator';
import KeepToast from './toast';

// 指令式组件
import '../directives/index';
// 修改后的vant css以及子令样式
import '../styles/directive.less';
import '../styles/vant.less';
// UI字体图标
import '../assets/iconfont/iconfont.scss';
// })(window, document);

const components: { [propsName: string]: any } = {
  KeepNavBar,
  KeepButtonGroups,
  KeepActionSheet,
  KeepCellAddress,
  KeepCellCheckbox,
  KeepCellPanel,
  KeepCellRadio,
  KeepCellStepper,
  KeepCellSwitch,
  KeepCollapse,
  KeepDatePickerView,
  KeepBadge,
  KeepRate,
  KeepList,
  KeepOptionModal,
  KeepTipsModal,
  KeepPicker,
  KeepTabBar,
  ...KeepCollapse,
  ...KeepActIndicator,
  KeepToast,
  KeepCorner,
};

const install = (vue: typeof Vue): void => {
  Object.keys(components).forEach((key) => {
    vue.component(key, components[key]);
  });
};

export default {
  install,
  ...components,
};


